import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ListaService } from '../../_services/lista.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { Table } from 'primeng/table';
import { Funcionalidad } from '../../_models/funcionalidad';
import { ProductoAgricolaService } from '../../_services/producto-agricola.service';
import { ProductoAgricola } from '../../_models/producto-agricola';
import { PlagaProductoAgricola } from '../../_models/plaga-producto-agricola';
import { Plaga } from '../../_models/plaga';
import { PlagaProductoAgricolaService } from '../../_services/plaga-producto-agricola.service';
import { PlagaService } from '../../_services/plaga.service';
import { ControlPlagaService } from '../../_services/control-plaga.service';
import { ControlPlaga } from '../../_models/control-plaga';
import { forkJoin } from 'rxjs';

@Component( {
  selector: 'app-plaga-detalle',
  templateUrl: 'plaga-detalle.component.html'
} )

export class PlagaDetalleComponent implements OnInit {
  formulario: FormGroup;

  /** Listas */
  lisPlagaProducto: PlagaProductoAgricola[] = [];

  columnasControlPlaga: any[] = [];
  columnasProducto: any[] = [];
  carInformacionInicial = true;
  submitted = false;
  guardando = false;
  carTabla = true;
  @ViewChild('dt') tabla: Table;
  menu: Funcionalidad = new Funcionalidad();
  plaga: Plaga = null;
  lisPlagaProductoComercial: ControlPlaga[] = [];


  constructor(
    private conServicio: ConfirmationService,
    private fb: FormBuilder,
    private serPlagaProductoAgricola: PlagaProductoAgricolaService,
    private route: ActivatedRoute,
    private lisServicio: ListaService,
    private navServicio: NavService,
    private router: Router,
    private autServicio: AutenticacionService,
    private serProductoAgricola: ProductoAgricolaService,
    private serPlaga: PlagaService,
    private serControlPlaga: ControlPlagaService
  ) {
  }

  ngOnInit() {

    this.route.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        /** Se carga la plaga producto comercial */
        this.serPlaga.obtenerPorId( params[ 'id' ] ).subscribe( registros => {
          this.plaga = registros;
          this.cargarInformacionInicial();
        } );
      }
    } );

  }

  cargarInformacionInicial() {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/plaga' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnasProducto = [
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'PLAGA.LBL_PRODAGRICOLA' ), sort: true },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: true }
    ];


    this.columnasControlPlaga = [
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'PLAGA.LBL_PRODCOMER' ), sort: true },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: true }
    ];

    forkJoin( this.serControlPlaga.listadoPorPlaga( this.plaga.idPlaga ),
      this.serPlagaProductoAgricola.listadoPorPlaga( this.plaga.idPlaga ) ).subscribe( ( [ controlPlaga, plagaProducto ] ) => {

      this.lisPlagaProductoComercial = controlPlaga;
      this.lisPlagaProducto = plagaProducto;
      this.carTabla = false;
      this.carInformacionInicial = false;
    } );

  }

}
